import script from "./CreateMemberModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateMemberModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreateMemberModal.vue?vue&type=style&index=0&id=b12c8a6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b12c8a6a"]])

export default __exports__